import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import React from 'react';

const Logo = ({ imageUrl, logoClass }) => {
  return (
    <div
      className={clsx(logoClass)}
      style={{
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginTop: '0px',
      }}
    >
      <Link to={process.env.PUBLIC_URL + '/'}>
        <img
          src={imageUrl}
          alt='Logo'
          style={{ Width: '100px', height: '100px' }}
        />
      </Link>
    </div>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  logoClass: PropTypes.string,
};

export default Logo;
